/* global Config */

// Vendor Libs
import {cloneDeep, get, includes, isEmpty, omitBy, set} from 'lodash';
import querystring from 'querystring';
import {CancelToken} from 'axios';
import cookie from 'react-cookies';

// Core Libs
import serviceCaller from '../lib-core/service-caller';

const omitQueryParams = query => omitBy(query, (val, key) => val === undefined || val === null || key === 'timeout');
const parseQuery = query => JSON.stringify(omitQueryParams(query));
const actionsServiceCaller = (actionParams, queryParams = {}, requestPath) => {
    const {cancelToken, dispatchCancel, dispatchFetched, dispatchError, servicesConfig} = actionParams;
    const {
        baseUrl,
        contentType,
        getParams,
        method,
        path,
        payloadType,
        responseType,
        timeout,
        useCustomPath,
    } = servicesConfig;
    const serviceParams = {
        dispatchCancel,
        dispatchFetched,
        dispatchError,
    };
    const ajaxParams = {
        baseURL: baseUrl,
        cancelToken,
        contentType,
        headers: {},
        method,
        params: cloneDeep(getParams) || {},
        paramsSerializer: querystring.stringify,
        responseType,
        timeout: get(queryParams, 'timeout') || timeout,
        url: requestPath ? `${path}/${requestPath}` : path,
    };
    const setCsrfTokenHeader = () => {
        const csrfToken = cookie.load(Config.base.csrfTokenCookieName);

        if (csrfToken) {
            ajaxParams.headers[Config.base.csrfTokenHeaderName] = csrfToken;
        }
    };

    const setCatalogHeader = () => {
        const providerIds =
            '1748107264,1885959796,1634361709,1870034030,1970170221,' +
            '1969513840,1819110912,1635283712,1684633856,1668247403,' +
            '1719232768,1853122423,1634231040,1668112760,1768161280,' +
            '1634559346,1735355494,1836412466,1752523264,1953391467,' +
            '1751936363,1853122415,1702064501,1935894784,1719171072,' +
            '1751281408,1936224119,1937011322,1702064245,1685286521,' +
            '1970274304,1701733234,1719168256,1650813294,1936747886,' +
            '1953325824,1633837926,1851941747,1986539875,1633837824,' +
            '1851941632,1718581248,1718579044,1751610486,1768317696,' +
            '1836348928,1685289060,1953653110,1953981184,1702064238,' +
            '1970495744,1937335929,1696661504,1629906176,1634558720,' +
            '1668117504,1684632419,1953260288,1751741300,1650816000,' +
            '1651668591,1836348978,1634757632,1970697070,1734438006,' +
            '1685285490,2003107840,1650615137,1719140352,1953918062,' +
            '1668113529,1818846821,1870166375,1986539776,1668178531,' +
            '1953916782,1852533362,1718973294,1937075812,1718973285,' +
            '1936024320,1835819630,1852400491,1651270010,1719169841,1870097920';
        set(ajaxParams, 'headers.ProtocolVersion', '1.27');
        set(ajaxParams, 'headers.Features', 'ADAPTIVE, CONTENT3D, DISABLE_TRICK_MODES,SHELVES, FOUR_K, EST, DAI, DYNA, RECOMMENDATIONS_SHELF');
        set(
            ajaxParams,
            'headers.CaIDs',
            '33208,33533,32778,32776,33054,33202,33227,33047,32796,33035,32773,32816,33068,33049,33534,33162,32922'
        );
        set(ajaxParams, 'headers.ProviderIDs', providerIds);
    };

    setCsrfTokenHeader();
    setCatalogHeader();

    if (!isEmpty(queryParams)) {
        if (includes(['POST', 'PUT', 'PATCH'], method) && payloadType !== 'params') {
            ajaxParams.headers['Content-Type'] = contentType || 'application/json';
            ajaxParams.data = parseQuery(queryParams);
        } else {
            ajaxParams.params = omitQueryParams({...ajaxParams.params, ...queryParams});
        }
    }

    return serviceCaller(serviceParams, ajaxParams);
};

export const generateCancelToken = () => CancelToken.source();
export default actionsServiceCaller;
